/**
 * @description  Widget labels entry
 */

export default Object.freeze({
  RGPD: 'rgpd',
  TEASER: 'teaserlabel',
  FULL_FRAME: 'chatboxlabel',
  EMAIL: 'email',
  PRINT: 'print',
})
